import { render, staticRenderFns } from "./BaseTLContextMenu.vue?vue&type=template&id=15d66f3e&"
import script from "./BaseTLContextMenu.vue?vue&type=script&lang=ts&"
export * from "./BaseTLContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports